(function(){

    const stickyATC = document.getElementById("td__atc__sticky");

    const myScrollFunc = () => {
        var y = window.scrollY;
        if (y >= 800) {
          stickyATC.classList.add('show_td__atc__sticky');
        } else {
          stickyATC.classList.remove('show_td__atc__sticky');
        }
    };

    window.addEventListener("scroll", myScrollFunc);

})();